import BootstrapSwitchButton from "bootstrap-switch-button-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { privateRequest } from "../../../api/apiConfig/privateRequest";
import { DATA_NOT_FOUND } from "../../../constant";
import { statusToggleFunc } from "../../../customHooks";
import { DeleteIcon, EditIcon } from "../../../Icon";
import Loader from "../../loader/Loader";
import Pagination from "../../Reuseablecomponent/Pagination";
import SearchHeader from "../../Reuseablecomponent/SearchHeader";
import DeleteModal from "../Modals/DeleteModal";
import MasterModal from "../Modals/MasterModal";
import RoleModal from "../Modals/RoleModal";

const RoleList = () => {
  const [roledata, setRoleData] = useState([]);
  const [data, setData] = useState([]);
  const [pageCount, setPageCount] = useState();
  const [message, setMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isdeletemodal, setIsdeletemodal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [reload, setReload] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [pageCounter, setPageCounter] = useState(null);
  const [loader, setLoder] = useState(false);

  const getSearchValue = (value) => {
    setSearchValue(value);
  };
  const getRole = async () => {
    setLoder(true);
    try {
      const { data } = await privateRequest.get(`/role?search=${searchValue}`);
      setPageCount(data.data.count);
      setMessage(data.message);
      setRoleData(data.data.data);
      setLoder(false);
    } catch (error) {
      setPageCount();
      setMessage("");
      setRoleData([]);
      setLoder(false);
    }
  };
  const openModal = (e, value) => {
    setIsOpen(true);
    setData(value);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const openDeleteModal = (id) => {
    setIsdeletemodal(true);
    setDeleteId(id);
  };
  const closeDeleteModal = () => {
    setIsdeletemodal(false);
    setDeleteId(null);
  };
  const getPageCount = () => {
    if (message == "Success") {
      const count = Math.ceil(pageCount / pageSize);
      setPageCounter(count);
    }
  };
  const handleActiveUser = async (value, id) => {
    statusToggleFunc("role", id, setReload, value);
  };
  const deletePropsConfig = {
    closeDeleteModal,
    isdeletemodal,
    url: "role",
    deleteId: deleteId,
    setReload,
  };
  const crudConfig = {
    title: "Role",
    isOpen,
    closeModal,
    data,
    url: "role",
    setReload,
  };

  useEffect(() => {
    getPageCount();
    getRole();
  }, [reload, searchValue]);

  return (
    <div>
      <SearchHeader
        title="Role"
        openModal={openModal}
        getSearchValue={getSearchValue}
        setPageNo={setPageNo}
      />
      {/* {isOpen && <MasterModal {...crudConfig}  />} */}
      {isdeletemodal && <DeleteModal {...deletePropsConfig} />}
      {isOpen && <RoleModal {...crudConfig} />}

      <div className="usertab">
        <div className="users">
          <table className="users__table">
            <thead className="users__table--thead">
              <tr>
                <th>Role Name</th>
                {/* <th>Is Active</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody className="users__table--tbody">
              {loader ? (
                <tr>
                  <td>
                    <Loader />
                  </td>
                </tr>
              ) : roledata.length === 0 ? (
                <tr>
                  <td colSpan={3} style={{ textAlign: "center", color: "red" }}>
                    {DATA_NOT_FOUND}
                  </td>
                </tr>
              ) : (
                roledata.map((data) => (
                  <tr key={data.id}>
                    <td className="tbodyTR">
                      <Link
                        className="tbodyTR_link"
                        to={`/role/permission/${data.id}`}
                      >
                        <div className="tbodyTR_div">{data.roleName}</div>
                      </Link>
                    </td>

                    <td>
                      <EditIcon openModal={openModal} data={data} />
                      <DeleteIcon
                        openDeleteModal={openDeleteModal}
                        data={data}
                        enable={true}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      {/* {pageCounter !== null && (
        <Pagination
          setPageNo={setPageNo}
          pageSize={pageSize}
          setPageSize={setPageSize}
          pageCounter={pageCounter}
        />
      )} */}
    </div>
  );
};

export default RoleList;
